import { defineStore } from 'pinia'
import { ref } from 'vue'
import { TLog } from '../../types'

export const useScrapStore = defineStore('Scrap', () => {
  const scrap = ref<Array<Partial<TLog>>>([])

  const setScrap = (payload: Array<Partial<TLog>>) => {
    scrap.value = payload
  }

  return {
    scrap,
    setScrap,
  }
})
